export enum TestingPresetKey {
    REJECT_ALL_OFFERS = 'REJECT_ALL_OFFERS',
    VIN_VALIDATION_DISABLED = 'VIN_VALIDATION_DISABLED',
    REJECT_GET_OFFER = 'REJECT_GET_OFFER',
    MOBILE_CONSOLE_ENABLED = 'MOBILE_CONSOLE_ENABLED',
}
